import Provisions from './provisions.component';
import { Config } from './provisions.config';

export default { Component: Provisions, config: Config };
